import React from 'react'

import SortArrowActive from 'assets/icons/sort-icon-active'
import SortArrowDefault from 'assets/icons/sort-icon'

import { SortButtonContainer } from './style'

export default function SortingArrow({
  checked,
  onChange
}) {
  return (
    <SortButtonContainer data-testid='test-button-container' onClick={onChange}>
      {checked ? <div data-testid="sorting-arrow-active"><SortArrowActive /></div> : <div data-testid='sorting-arrow-default'><SortArrowDefault /></div>}
    </SortButtonContainer>
  )
}
